import { defineMessages } from 'react-intl';

export default defineMessages({
  totalIncTax: {
    id: 'account.orderHistory.detail.totalIncTax',
    defaultMessage: 'Order Total (Incl. Tax)',
  },
  grandTotal: {
    id: 'shop.cart.grandTotal',
    defaultMessage: 'Order Total',
  },
  exTax: {
    id: 'shop.cart.ExTax',
    defaultMessage: 'Excl. Tax',
  },
  inclTax: {
    id: 'shop.cart.IncTax',
    defaultMessage: 'Incl. Tax',
  },
  shippingHandling: {
    id: 'common.titles.shippingHandling',
    defaultMessage: 'Shipping & Handling',
  },
  // TODO: make these common.title keys to share with shop cart
  itemDownloadableIndicator: {
    id: 'shop.cart.itemDownloadableIndicator',
    defaultMessage: 'Download',
  },
  subtotal: {
    id: 'shop.cart.subtotal',
    defaultMessage: 'Subtotal',
  },
  discount: {
    id: 'shop.cart.discountLabel',
    defaultMessage: 'Discount',
  },
});
